/* menu-renderer.js */
/* Renders the old design structure from a single centralized data source. */

(function () {
  function ensureGlobalLayer(className, html) {
    let layer = document.querySelector(`.${className}`);
    if (!layer) {
      layer = document.createElement('div');
      layer.className = className;
      document.body.appendChild(layer);
    }
    layer.innerHTML = html;
    return layer;
  }

  function renderRoots() {
    const data = window.CUSTOM_NAVIGATION_DATA || {};
    const roots = document.querySelectorAll('.js-custom-nav-root');
    if (!roots.length) return;

    roots.forEach((root) => {
      root.innerHTML = data.topNavHtml || '';
    });

    if (data.mobileMenuHtml) {
      ensureGlobalLayer('js-custom-nav-mobile-layer', data.mobileMenuHtml);
    }

    if (data.desktopOverlayHtml) {
      ensureGlobalLayer('js-custom-nav-desktop-layer', data.desktopOverlayHtml);
    }
  }

  function init() {
    renderRoots();
    document.documentElement.classList.add('custom-nav-rendered');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
